<template>
  <Highcharts
    ref="chart"
    :options="chartOptions"
  />
</template>
<script>
import { Chart } from 'highcharts-vue';
import formatterTooltip from './formatter-tooltip.js';
import formatterLabel from './formatter-label.js';
import { formatNumber } from '@/utils';

export default {
  name: 'Pie',
  components: {
    Highcharts: Chart,
  },
  props: {
    total: {
      type: Number,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    overrideChartOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    chartOptions() {
      const totalFollowers = formatNumber(this.total);

      return {
        chart: {
          type: 'pie',
          height: '300px',
          events: {
            load() {
              const text = `
                <div class="total-fans">
                  <span class="total-fans__label">${totalFollowers}</span><br>
                  <span class="total-fans__number">Total de fãs/inscritos</span>
                </div>
              `;

              this.renderer
                .text(text, 145, 75)
                .attr({ useHTML: true })
                .add();
            },
          },
        },
        legend: {
          labelFormatter() {
            return formatterLabel(this, false);
          },
          width: 320,
          height: 20,
          align: 'left',
          layout: 'vertical',
          verticalAlign: 'top',
          floating: true,
          useHTML: true,
          y: 140,
          x: -20,
        },
        title: {
          text: '',
        },
        tooltip: {
          shared: true,
          borderColor: 'none',
          useHTML: true,
          formatter() {
            return formatterTooltip(this);
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            borderColor: '#ffffff',
            borderWidth: '1',
            cursor: true,
            size: 120,
            center: [40, 40],
            innerSize: '65%',
            dataLabels: {
              enabled: false,
            },
            point: {
              events: {
                legendItemClick: (e) => {
                  this.$emit('legend-click', { legend: e.target.name });
                },
              },
            },
          },
          series: {
            animation: false,
            shadow: false,
            states: {
              hover: {
                halo: {
                  size: 4,
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            showInLegend: true,
            data: this.data,
          },
        ],
        ...this.overrideChartOptions,
      };
    },
  },
};
</script>

<style lang="scss">
.highcharts {
  &-tooltip {
    border: none;

    &-box {
      fill: none;
      fill-opacity: 1;
      stroke-width: 0;
      border-radius: 10px;
    }
  }
}

.title-chart {
  color: var(--ds-color-text-1);
  font-size: var(--ds-font-size-md);
  line-height: var(--ds-font-size-lg);
  font-weight: var(--ds-font-weight-semibold);
}

.total-fans {
  &__label {
    fill: var(--ds-color-text-1);
    font-size: var(--ds-font-size-md);
    font-weight: var(--ds-font-weight-semibold);
  }

  &__number {
    fill: var(--ds-color-text-2);
    font-size: var(--ds-font-size-xs);
    font-weight: var(--ds-font-weight-regular);
  }
}

.label-item {
  display: grid;
  gap: var(--ds-spacing-stack-nano);
  grid-template-columns: minmax(60px, 1fr) minmax(var(--ds-spacing-inline-md), 1fr) minmax(46px, 1fr) 1fr;
  font-size: var(--ds-font-size-xs);
  margin: 0 0 var(--ds-spacing-inline-nano) 0;

  &__name {
    color: var(--ds-color-text-1);
    font-weight: var(--ds-font-weight-semibold);
  }

  &__fans {
    color: var(--ds-color-text-2);
    font-weight: var(--ds-font-weight-semibold);
    text-align: right;
  }

  &__percent {
    color: var(--ds-color-text-1);
    font-weight: var(--ds-font-weight-semibold);
    text-align: right;
  }

  &__variation {
    display: flex;
  }

  &__ds-icon {
    margin-right: var(--ds-spacing-inline-quark);
    background: var(--ds-color-icon-3);
    -webkit-mask-position: center center;
    mask-position: center center;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: cover;
    mask-size: cover;
    vertical-align: middle;
    width: 15px;
    height: 15px;
    margin-top: 1px;
  }

  &__variation-value {
    font-weight: var(--ds-font-weight-semibold);
    font-size: var(--ds-font-size-xs);
    text-align: left;
  }
}

.tooltip-pie {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  box-shadow: var(--ds-light-dropshadow-1);
  padding: var(--ds-spacing-stack-xs);
  border-radius: var(--ds-border-radius-sm);
  background: var(--ds-color-neutral);

  &__bottom {
    margin-top: var(--ds-spacing-stack-nano);
  }

  &__point {
    border-radius: var(--ds-border-radius-pill);
    margin-right: var(--ds-spacing-stack-nano);
    padding: var(--ds-spacing-stack-quark);
  }

  &__name {
    color: var(--ds-color-text-1);
    font-weight: var(--ds-font-weight-semibold);
  }

  &__fans {
    color: var(--ds-color-text-2);
    margin-right: var(--ds-spacing-stack-nano);
    font-weight: var(--ds-font-weight-semibold);
  }

  &__percent {
    color: var(--ds-color-text-1);
    font-weight: var(--ds-font-weight-regular);
  }
}
</style>
